import PropTypes from 'prop-types'
import { useStyletron } from 'baseui'
import Icon from 'baseui/icon/icon'

const IconGoogleCalendar = ({ size = 32, title = 'Google Calendar', overrides }) => {
  const [, theme] = useStyletron()

  return (
    <Icon
      viewBox="0 0 48 48"
      size={size}
      title={title}
      overrides={overrides}
      color="none"
    >
      <title>{title}</title>
      <rect x="4" y="6" width="40" height="38" rx="4" ry="4" fill="#ffffff" stroke="#dadce0"/>
      <rect x="4" y="6" width="40" height="8" fill="#1967d2" />
      <text
        x="24"
        y="34"
        textAnchor="middle"
        fontSize="18"
        fontWeight="bold"
        fill="#1967d2"
        fontFamily="Arial, sans-serif"
      >
        31
      </text>
    </Icon>
  )
}

IconGoogleCalendar.propTypes = {
  size: PropTypes.number,
  title: PropTypes.string,
  overrides: PropTypes.object,
}

export default IconGoogleCalendar
